import { EmailValidationModal, Loader } from "components";
import { useResendEmailVerification } from "hooks";

interface OnboardingProps {
  show: boolean;
  close: () => void;
  email: string;
}

const EmailVerificationPrompt: React.FC<OnboardingProps> = ({
  show,
  close,
  email,
}) => {

  // API Request Hooks
    const { mutate: resendEmailVerification, isPending: resendPending } = useResendEmailVerification();

  return (
    <>
      <Loader loading={resendPending} />
      <EmailValidationModal
        show={show}
        close={close}
        onResend={() => resendEmailVerification({ email })}
        resending={resendPending}
      />
    </>
  );
};

export { EmailVerificationPrompt };
